module.exports = __webpack_public_path__ + "img/icon_jifen.2d2f76db.png";